import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { mergeParams } from "../../../helpers/helpers";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const [lista, setLista] = useState([]);
  const [filtros, setFiltros] = useState(
    mergeParams({ nome: "", CPF: "", email: "" }, location)
  );
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);

    api
      .get("consultores/listar", filtrosEnviar)
      .then((res) => {
        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar consultores");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: filtros.nome,
      },
      CPF: {
        label: "CPF",
        type: "number",
        space: 3,
        value: filtros.CPF,
      },
      email: {
        label: "Email",
        type: "text",
        space: 3,
        value: filtros.email,
      },
    },
    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirConsultor = (registro) => {
    history.push(`/app/consultor/${registro.id}`);
  };

  const tRegistros = {
    title: "Consultores",
    onLineClick: abrirConsultor,
    newItemAction: () => history.push("/app/consultor/0"),
    columns: [
      {
        name: "usuarioNome",
        label: "Nome",
      },
      {
        name: "usuarioCpf",
        label: "CPF",
      },
      {
        name: "usuarioEmail",
        label: "Email",
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
